/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ExpressionType;
(function (ExpressionType) {
    ExpressionType["Account"] = "ACCOUNT";
    ExpressionType["Dimension"] = "DIMENSION";
})(ExpressionType || (ExpressionType = {}));
export function ExpressionTypeFromJSON(json) {
    return ExpressionTypeFromJSONTyped(json, false);
}
export function ExpressionTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ExpressionTypeToJSON(value) {
    return value;
}
